import React, { useState, useEffect } from "react";
import SwipeableViews from "react-swipeable-views";
import { Box, Typography, Button, IconButton } from "@mui/material";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import { motion } from "framer-motion";
import img2 from '../../assets/shop/Banner2.png'

const slides = [
    {
        desktop: img2,
        mobile: "https://www.anveshan.farm/cdn/shop/files/NEW_MOBILE_SIZE_4.webp?v=1751480946",
        // link: "/collections/all-products",
    },
];

// Content for each slide - Updated for Jyotish Jigyasa
const slideContents = [
    {
        title: "Ancient Wisdom for Modern Life",
        description: [
            "5000+ Years Tradition",
            "Personalized Birth Charts",
            "Accurate Predictions",
        ],
        buttonText: "Get Reading",
    },
    {
        title: "Unlock Your Cosmic Blueprint",
        description: "Discover your life's purpose and navigate challenges with Vedic astrological guidance.",
        buttonText: "Book Consultation",
    },
    {
        title: "Planetary Insights for Better Living",
        description: "Understand how cosmic energies influence your relationships, career, and personal growth.",
        buttonText: "Explore Services",
    },
];

const HappyFarmers = () => {
    const [index, setIndex] = useState(0);

    const handleNext = () => {
        setIndex((prev) => (prev + 1) % slides.length);
    };

    const handlePrev = () => {
        setIndex((prev) => (prev - 1 + slides.length) % slides.length);
    };

    useEffect(() => {
        const interval = setInterval(() => {
            setIndex((prev) => (prev + 1) % slides.length);
        }, 5000);
        return () => clearInterval(interval);
    }, []);

    // Animation variants
    const contentVariants = {
        hidden: { opacity: 0, x: 50 },
        visible: { 
            opacity: 1, 
            x: 0, 
            transition: { 
                duration: 0.8,
                ease: "easeOut"
            } 
        },
    };

    const buttonVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: { 
            opacity: 1, 
            y: 0, 
            transition: { 
                duration: 0.6,
                delay: 0.4 
            } 
        },
        hover: {
            scale: 1.05,
            backgroundColor: "#6d1675",
            color: "#fff",
            transition: { duration: 0.3 }
        }
    };

    return (
        <Box
            sx={{
                position: "relative",
                overflow: "hidden",
                height: { xs: 450,  md: 440 },
                maxWidth: "100%",
                // pb: 2,
                bgcolor: "rgba(255, 234, 223, 0.3)",
            }}
        >
            <SwipeableViews index={index} onChangeIndex={setIndex} enableMouseEvents>
                {slides.map((slide, i) => (
                    <a
                        key={i}
                        // href={slide.link}
                        style={{ display: "block", width: "100%" }}
                    >
                        <picture>
                            <source media="(min-width:1024px)" srcSet={slide.desktop} />
                            <img
                                src={slide.mobile}
                                alt="Vedic Astrology Services"
                                loading="eager"
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                    display: "block",
                                }}
                            />
                        </picture>
                    </a>
                ))}
            </SwipeableViews>

            {/* Navigation Arrows */}
            <Box
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: 16,
                    transform: "translateY(-50%)",
                    zIndex: 10,
                }}
            >
                <IconButton 
                    onClick={handlePrev} 
                    sx={{ 
                        color: "white",
                        backgroundColor: "rgba(109, 22, 117, 0.7)",
                        "&:hover": { backgroundColor: "#6d1675" },
                    }}
                >
                    <ArrowBackIos />
                </IconButton>
            </Box>
            <Box
                sx={{
                    position: "absolute",
                    top: "50%",
                    right: 16,
                    transform: "translateY(-50%)",
                    zIndex: 10,
                }}
            >
                <IconButton 
                    onClick={handleNext} 
                    sx={{ 
                        color: "white",
                        backgroundColor: "rgba(109, 22, 117, 0.7)",
                        "&:hover": { backgroundColor: "#6d1675" },
                    }}
                >
                    <ArrowForwardIos />
                </IconButton>
            </Box>

            {/* Dots Indicator */}
            <Box
                sx={{
                    position: "absolute",
                    bottom: 16,
                    left: "50%",
                    transform: "translateX(-50%)",
                    display: "flex",
                    justifyContent: "center",
                    gap: 1,
                    zIndex: 10,
                }}
            >
                {slides.map((_, i) => (
                    <Box
                        key={i}
                        onClick={() => setIndex(i)}
                        sx={{
                            width: 12,
                            height: 12,
                            borderRadius: "50%",
                            backgroundColor: i === index ? "#ffc20f" : "rgba(255,255,255,0.5)",
                            cursor: "pointer",
                            border: i === index ? "2px solid #6d1675" : "none",
                            transition: "all 0.3s ease",
                        }}
                    />
                ))}
            </Box>

            {/* Content box */}
            <Box
                component={motion.div}
                variants={contentVariants}
                initial="hidden"
                animate="visible"
                key={index} // Re-trigger animation on slide change
                sx={{
                    position: "absolute",
                    top: 0,
                    right: 0,
                    width: { xs: "100%", md: "50%" },
                    height: "100%",
                    backgroundColor: "rgba(109, 22, 117, 0.85)",
                    color: "#fff",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: 4,
                    boxSizing: "border-box",
                    textAlign: "center",
                }}
            >
                <Typography
                    gutterBottom
                    sx={{
                        fontWeight: "bold",
                        mb: { xs: 2, md: 4 },
                        letterSpacing: 1,
                        fontSize: { xs: "24px", md: "32px" },
                        lineHeight: 1.2,
                        color: "#fff",
                    }}
                >
                    {slideContents[index].title}
                </Typography>

                {/* Description with conditional formatting */}
                {Array.isArray(slideContents[index].description) ? (
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            gap: 4,
                            mb: { xs: 2, md: 4 },
                            flexWrap: "wrap",
                        }}
                    >
                        {slideContents[index].description.map((line, i) => {
                            const firstSpaceIndex = line.indexOf(" ");
                            const numberPart = line.slice(0, firstSpaceIndex);
                            const textPart = line.slice(firstSpaceIndex + 1);

                            return (
                                <Box
                                    key={i}
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        textAlign: "center",
                                        maxWidth: 160,
                                    }}
                                >
                                    <Typography
                                        component="div"
                                        sx={{
                                            fontWeight: "bold",
                                            fontSize: { xs: "20px", md: "28px" },
                                            lineHeight: 1,
                                            color: "#ffc20f",
                                        }}
                                    >
                                        {numberPart}
                                    </Typography>
                                    <Typography
                                        component="div"
                                        sx={{ 
                                            fontSize: { xs: "14px", md: "16px" }, 
                                            mt: 1,
                                            color: "#fff",
                                            fontWeight: 500,
                                        }}
                                    >
                                        {textPart}
                                    </Typography>
                                </Box>
                            );
                        })}
                    </Box>
                ) : (
                    <Typography
                        variant="body1"
                        sx={{ 
                            mb: 3, 
                            fontSize: { xs: "16px", md: "20px" },
                            color: "#fff",
                            lineHeight: 1.6,
                            maxWidth: "80%",
                        }}
                    >
                        {slideContents[index].description}
                    </Typography>
                )}

                <motion.div
                    variants={buttonVariants}
                    initial="hidden"
                    animate="visible"
                    whileHover="hover"
                >
                    <Button
                        variant="contained"
                        sx={{
                            px: 4,
                            py: 1.5,
                            fontWeight: "bold",
                            borderRadius: 50,
                            color: "#6d1675",
                            backgroundColor: "#ffc20f",
                            fontSize: "16px",
                            textTransform: "none",
                            minWidth: 160,
                            boxShadow: "0 4px 15px rgba(255, 194, 15, 0.3)",
                            "&:hover": {
                                backgroundColor: "#6d1675",
                                color: "#fff",
                                boxShadow: "0 6px 20px rgba(109, 22, 117, 0.4)",
                            },
                        }}
                        onClick={() =>
                            alert(`Clicked on: ${slideContents[index].buttonText}`)
                        }
                    >
                        {slideContents[index].buttonText}
                    </Button>
                </motion.div>
            </Box>
        </Box>
    );
};

export default HappyFarmers;